var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap",
      staticStyle: { width: "1200px", height: "410px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(_vm._s(_vm.$t("msg.ONEX050T010.044"))),
        ]),
        _c(
          "div",
          { staticClass: "content_box", staticStyle: { height: "260px" } },
          [
            _c("table", { staticClass: "tbl_col font_sm mt10" }, [
              _vm._m(0),
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.054")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.055")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.056")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.057")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.058")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.059")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.060")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.058")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.061")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.SCHD010P040.062")))]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.callingPort, function (item, lvlDiv) {
                  return _c("tr", { key: lvlDiv }, [
                    _c("td", [_vm._v(_vm._s(item.rteCd))]),
                    _c("td", [_vm._v(_vm._s(item.vslNm))]),
                    _c("td", [_vm._v(_vm._s(item.etVoyNo))]),
                    _c("td", [_vm._v(_vm._s(item.polPortCd))]),
                    _c("td", [_vm._v(_vm._s(item.polTrmlCd))]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.$ekmtcCommon.changeDatePattern(item.polEtd, ".")
                        )
                      ),
                    ]),
                    _c("td", [_vm._v(_vm._s(item.podPortCd))]),
                    _c("td", [_vm._v(_vm._s(item.podTrmlCd))]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.$ekmtcCommon.changeDatePattern(item.podEta, ".")
                        )
                      ),
                    ]),
                    _c("td", [_vm._v(_vm._s(item.trstList))]),
                  ])
                }),
                0
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "mt10 text_center" }, [
          _c(
            "a",
            {
              staticClass: "button gray lg",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("msg.SCHD010P040.046")) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "5%" } }),
      _c("col", { staticStyle: { width: "10%" } }),
      _c("col", { staticStyle: { width: "5%" } }),
      _c("col", { staticStyle: { width: "5%" } }),
      _c("col", { staticStyle: { width: "5%" } }),
      _c("col", { staticStyle: { width: "10%" } }),
      _c("col", { staticStyle: { width: "5%" } }),
      _c("col", { staticStyle: { width: "5%" } }),
      _c("col", { staticStyle: { width: "10%" } }),
      _c("col", { staticStyle: { width: "10%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }